(() => {
  function initialize(root) {
    if (!window.MarlenCommerce) { document.addEventListener('marlen:ready', () => initialize(root), {once:true}); return; }
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const gallery = root.querySelector('[data-gallery-stage]');
    if (gallery) {
      const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
      function markImage(slide) {
        slides.forEach(item => item.classList.toggle('is-active', item === slide));
        thumbs.forEach(thumb => {
          if (thumb.dataset.galleryThumb === slide.dataset.galleryIndex) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      }
      thumbs.forEach(thumb => thumb.addEventListener('click', event => {
        event.preventDefault();
        const slide = slides.find(item => item.dataset.galleryIndex === thumb.dataset.galleryThumb);
        if (!slide) return;
        slide.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center'});
        markImage(slide);
      }));
      gallery.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const index = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
        const next = slides[(index + (event.key === 'ArrowLeft' ? 1 : -1) + slides.length) % slides.length];
        next.scrollIntoView({behavior:'auto', block:'nearest', inline:'center'});
        markImage(next);
      });
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting && entry.intersectionRatio > .6) markImage(entry.target); });
      }, {root: gallery, threshold: [.6]});
      slides.forEach(slide => observer.observe(slide));
    }
    const form = root.querySelector('.mbp-form');
    const quantity = form.querySelector('[name="quantity"]');
    const add = form.querySelector('[data-add]');
    const sticky = root.querySelector('[data-sticky]');
    const buttons = [...root.querySelectorAll('[data-purchase]')];
    const status = root.querySelector('[data-form-status]');
    const stickyStatus = root.querySelector('[data-sticky-status]');
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    let selected = variants.find(v => String(v.id) === form.querySelector('[name="id"]').value);
    let pending = false;
    const commerce = window.MarlenCommerce;
    const addon = commerce.config.recommendations[root.dataset.productId];
    const options = form.querySelector('[data-addon-options]');
    if (addon?.available && String(addon.id) !== root.dataset.productId) {
      options.hidden = false;
      form.querySelector('[data-addon-title]').textContent = 'البكج + ' + addon.title;
      form.querySelector('[data-addon-cost]').textContent = '+ ' + commerce.money(addon.price);
      const image = form.querySelector('[data-addon-image]'); image.src = addon.image; image.alt = addon.title;
    }
    const combined = () => !options.hidden && form.querySelector('[name="bundle_option"]:checked')?.value === 'combined';
    function updateTotal() {
      const total = (selected.rawPrice + (combined() ? addon.price : 0)) * Number(quantity.value || 1);
      root.querySelector('[data-order-total]').textContent = commerce.money(total);
      root.querySelector('[data-sticky-price]').textContent = commerce.money(total);
    }
    form.querySelectorAll('[name="bundle_option"]').forEach(input => input.addEventListener('change', updateTotal));
    updateTotal();

    function setStatus(message) {
      status.textContent = stickyStatus.textContent = message;
    }
    function updateButtons() {
      buttons.forEach(button => {
        button.disabled = pending || !selected.available;
        button.querySelector('[data-button-label]').textContent = !selected.available ? 'نفذت الكمية' : pending ? 'لحظة…' : button.hasAttribute('data-buy') ? 'اشتري الآن' : 'أضيفي للسلة';
      });
    }
    function normalizeQuantity() {
      const min = selected.min || 1;
      const step = selected.step || 1;
      let value = Math.max(min, Number(quantity.value) || min);
      value = min + Math.floor((value - min) / step) * step;
      if (selected.max != null) value = Math.min(value, selected.max);
      quantity.value = value;
      updateTotal();
    }
    root.querySelectorAll('[data-quantity-change]').forEach(button => {
      button.addEventListener('click', () => {
        quantity.value = Number(quantity.value) + Number(button.dataset.quantityChange) * (selected.step || 1);
        normalizeQuantity();
        setStatus('');
      });
    });
    quantity.addEventListener('input', () => { if (Number(quantity.value) > 0) updateTotal(); });
    quantity.addEventListener('change', () => { normalizeQuantity(); setStatus(''); });

    root.querySelector('[data-variant-select]')?.addEventListener('change', event => {
      selected = variants.find(v => String(v.id) === event.target.value);
      if (!selected) return;
      root.querySelector('[data-price]').textContent = selected.price;
      root.querySelector('[data-sticky-price]').textContent = selected.price;
      const compare = root.querySelector('[data-compare]');
      const saving = root.querySelector('[data-saving]');
      compare.textContent = selected.compare;
      compare.hidden = !selected.sale;
      saving.textContent = selected.saving;
      saving.hidden = !selected.sale;
      root.querySelector('[data-availability]').textContent = selected.available ? 'متوفر للطلب' : 'نفذت الكمية حالياً';
      updateButtons();
      quantity.min = selected.min;
      quantity.step = selected.step;
      if (selected.max != null) quantity.max = selected.max;
      else quantity.removeAttribute('max');
      normalizeQuantity();
      setStatus('');
      const url = new URL(location.href);
      url.searchParams.set('variant', selected.id);
      history.replaceState({}, '', url);
    });

    form.addEventListener('submit', async event => {
      event.preventDefault();
      // منع معالج السلة العام من إرسال الطلب نفسه مرة ثانية.
      event.stopPropagation();
      if (pending || !selected.available) return;
      const buyNow = event.submitter?.hasAttribute('data-buy');
      const checkoutPath = event.submitter?.value;
      normalizeQuantity();
      if (!form.reportValidity()) return;
      pending = true;
      updateButtons();
      setStatus('');
      try {
        const items = [{id:selected.id, quantity:Number(quantity.value)}];
        if (combined()) items.push({id:addon.variantId, quantity:Number(quantity.value)});
        await commerce.addItems(items);
        if (buyNow) {
          setStatus('جاري الانتقال لإكمال الطلب…');
          location.assign(checkoutPath || (window.Shopify?.routes?.root || '/') + 'checkout');
          return;
        }
        setStatus('انضاف البكج للسلة.');
        if (typeof window.refreshCartDrawer === 'function') window.refreshCartDrawer();
        if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
        else location.href = (window.Shopify?.routes?.root || '/') + 'cart';
      } catch (error) {
        setStatus(error.message || 'تعذّرت الإضافة، جرّبي مرة ثانية.');
        commerce.showError(error.message);
      } finally {
        pending = false;
        updateButtons();
      }
    });
    if ('IntersectionObserver' in window) {
      gallery.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const index = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
        const next = slides[(index + (event.key === 'ArrowLeft' ? 1 : -1) + slides.length) % slides.length];
        next.scrollIntoView({behavior:'auto', block:'nearest', inline:'center'});
        markImage(next);
      });
      const observer = new IntersectionObserver(entries => {
        sticky.classList.toggle('is-shown', !entries[0].isIntersecting && entries[0].boundingClientRect.bottom <= 0);
      });
      observer.observe(add);
      root.bundleObserver = observer;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('[data-bundle-page]').forEach(initialize));
  else document.querySelectorAll('[data-bundle-page]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bundle-page]').forEach(initialize));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-bundle-page]').forEach(root => root.bundleObserver?.disconnect()));
})();
